<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-[50vw] max-w-full lg:w-[33.33vw]">
  <ng-template #header>
    <div class="flex-flex-col w-full gap-1">
      <label class="text-left font-bold">{{ 'editService' | translate }}</label>
      <p-divider />
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
      <label for="serviceId" class="text-left font-semibold">ID</label>
      <input pInputText id="serviceId" class="orgdept-input col-span-2" [disabled]="true" [(ngModel)]="service.serviceId" />

      <label for="name" class="text-left font-semibold">{{ 'code' | translate }}</label>
      <input pInputText id="name" class="orgdept-input col-span-2" [disabled]="true" [(ngModel)]="service.name" />
    </div>

    <div class="grid grid-cols-3 items-center gap-3">
      <label class="col-start-1 text-left">{{ 'mode' | translate }}</label>
      <p-selectbutton [options]="modeOptions" [ngModel]="useLimit" [style]="{ background: 'var(--primary-900)' }" optionLabel="label" optionValue="value" (onOptionClick)=onModeSelection() />
    </div>
    <p-divider />
    <div class="grid grid-cols-3 gap-3">
      <label class="col-start-1 self-start text-left">{{ 'description' | translate }}</label>
      <textarea class="col-span-2 self-start" rows="5" cols="30" pTextarea [(ngModel)]="service.description"></textarea>

      <label class="col-start-1 self-center text-left">{{ 'functions.maxExecutions' | translate }}</label>
      <p-inputnumber class="orgdept-input col-span-2 self-center" [(ngModel)]="service.limit" [min]="0" [disabled]="!useLimit" />

      <label class="col-start-1 self-center text-left">{{ 'functions.maxMonths' | translate }}</label>
      <p-inputnumber class="orgdept-input col-span-2 self-center" [(ngModel)]="service.expirationMonths" [min]="1" [disabled]="useLimit" />

      <label class="col-start-1 self-center text-left">{{ 'functions.autoRenew' | translate }}</label>
      <p-toggleswitch class="orgdept-input self-center justify-self-start" [(ngModel)]="service.autoRenewal" />
    </div>
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.cancel' | translate"
              severity="secondary"
              variant="outlined"
              (click)="onClose()" />
    <p-button [label]="'save' | translate"
              (click)="onSave()" />
  </ng-template>
</p-dialog>
